import React, {Dispatch, SetStateAction, useEffect, useState} from 'react';
import s from './ExchangeStepTwo.module.css'
import style from '../../../../../styles/styles.module.css'
import TransparentButton from "../../../../../components/ui/TransparentButton/TransparentButton";
import Icon from "@ant-design/icons";
import {ReactComponent as Back} from "../../../../../assets/img/personalAccount/back.svg";
import MyBtn from "../../../../../components/ui/MyBtn/MyBtn";
import Table from "antd/es/table";
import CustomModal from "../../../../../components/ui/CustomModal/CustomModal";
import {sendPinCodeEmailTrans, SendTransferThunk, verifyOldEmailThunk} from "../../../../../store/reducers/ActionCreators";
import {useAppDispatch, useAppSelector} from "../../../../../hooks/redux";
import {ITransacton} from "../../../../../types/interfaces";
import tickCircle from "../../../../../assets/img/personalAccount/tick-circle.svg"
import closeCircle from "../../../../../assets/img/personalAccount/close-circle.svg"
import PopUpEmailCodConfirm from '../../../../../components/ui/PopUpEmailCodConfirm/PopUpEmailCodFonfirm';
import { setDisabled } from '../../../../../store/reducers/UserSlice';

type PropsType = {
    setCurrent: Dispatch<SetStateAction<number>>
    current: number
    exchangeData: Array<ITransacton>
}

const columns = [
    {
        title: 'from Account',
        dataIndex: 'fromAccount',
        className: `${s.short}`,
        align: 'left'
    },
    {
        title: 'To Account',
        dataIndex: 'toAccount',
        align: 'left',
        className: `${s.short}`,
    },
    {
        title: 'To sell',
        dataIndex: 'toSell',
        align: 'right',
        className: `${s.short}`,
    },
    {
        title: 'To buy',
        dataIndex: 'toBuy',
        align: 'right',
        className: `${s.short}`,
    },
    // {
    //     title: 'Ratio',
    //     dataIndex: 'ratio',
    //     align: 'right',
    //     className: `${s.short}`,
    // },
    Table.EXPAND_COLUMN,
];


export interface IExchangeBody {
    amount: number,
    from: string,
    to: string,
}

const ExchangeStepTwo = (props: PropsType) => {

    const [isSuccessPopupOpen, setIsSuccessPopupOpen] = useState<boolean | null>(false)
    const [isErrorPopupOpen, setIsErrorPopupOpen] = useState<boolean | null>(false)
    const [isNotEnoughMoney, setIsNotEnoughMoney] = useState<boolean | null>(false)
    const dispatch = useAppDispatch()
    const token = useAppSelector(state => state.userReducer.userToken)
    const accountId = useAppSelector(state => state.userReducer.chosenAccountTypeId)

    const [emailPinVerif, setEmailPin] = useState('')

    const [isEmailValid, setIsEmailValid] = useState('')

    const [showEmailModalVerify, setShowEmailModalVerify] = useState(false)

    const getEmailPin = (emailCode: string) => {
        setEmailPin(emailCode)
        sendExchangeData(emailCode)
    }

    const showEmailPinCodeModal = () => {
        setShowEmailModalVerify(true)
        dispatch(sendPinCodeEmailTrans(token))
    }

    const closeEmailPinPopUp = () => {
        setShowEmailModalVerify(false)
    }

    const clearEmailInput = () => {
        setIsEmailValid('')
        setIsErrorPopupOpen(false)
    }

    useEffect(() => {
                
            }, [isEmailValid]);

    const tableData = props.exchangeData.map((item: any, index: number) => {
        return {
            key: item.index,
            fromAccount: item.accNumberFrom,
            toAccount: item.accNumberTo,
            toSell: (item.amount ? item.amount : item.result) + ' ' + item.accNumberFromCurrency,
            toBuy: (item.toAmount? item.toAmount : item.result) + ' ' + item.accNumberToCurrency,
            // ratio: <>
            //     <p className={s.ratio_cell}>1 USD: 0.91 EUR;</p>
            //     <p className={s.ratio_cell}>1 EUR: 1.09 USD</p>
            // </>
        }
    })

    



    const sendExchangeData = (emailCode: string) => {
        const tempData = {
            ...props.exchangeData[0],
            amount: (props.exchangeData[0].amount && props.exchangeData[0].result) ? Number(props.exchangeData[0].amount) : props.exchangeData[0].result,
            accNumberFrom: props.exchangeData[0].hiddenAccountNumberFrom,
            accNumberTo: props.exchangeData[0].hiddenAccountNumberTo,
            accountId: accountId,
            emailCode
        }
        delete tempData.accNumberFromCurrency
        delete tempData.accNumberToCurrency
        delete tempData.toAmount
        delete tempData.result
        dispatch(SendTransferThunk(token, tempData, accountId))
            .then((res) => {
                if (res.data === 'Created') {
                    setIsSuccessPopupOpen(true)
                // } else {
                //     setIsErrorPopupOpen(true)
                // }
                }
            })
            .catch((e) => {
                if (e.response.data === "Not enough money to create transaction") {
                    setIsNotEnoughMoney(true)
                    return
                } else if (e.response.data = 'Invalid email code') {
                    setIsEmailValid(e.response.data)
                    setIsErrorPopupOpen(true)
                }
                else {setIsErrorPopupOpen(true)}
            }).finally(() => {
                dispatch(setDisabled(false))
              })
    }

    const closeAndRedirect = () => {
        setIsSuccessPopupOpen(false)
        props.setCurrent(0)
    }

    return (
        <div className={s.wrapper}>
            <CustomModal type="error" isNotify isModalOpen={isNotEnoughMoney} setIsModalOpen={setIsErrorPopupOpen}>
                <div className={style.modal_content}>
                    <div className={style.popup_subtitle}>
                        <span className={style.error}>Failed!</span> The transfer cannot be made due to insufficient funds.
                    </div>
                    <div className={style.popup_button_block}>
                        <MyBtn buttonType="error" isPersonalAccountBtn title={"Ok"} onClick={() => setIsNotEnoughMoney(false)}/>
                    </div>
                </div>
            </CustomModal>

            <CustomModal type="confirm" isModalOpen={isSuccessPopupOpen} setIsModalOpen={setIsSuccessPopupOpen}>
                <div className={s.modal_content}>
                    <img src={tickCircle} alt="" className={s.tick_circle}/>
                    <div className={s.popup_title}>
                        Success!
                    </div>
                    <div className={s.popup_subtitle}>
                        Your exchange has been
                        successfully completed.
                    </div>
                    <div className={s.popup_button_block}>
                        <MyBtn isPersonalAccountBtn title={'Ok'} medium onClick={() => closeAndRedirect()}/>
                    </div>
                </div>
            </CustomModal>
            <CustomModal type="error" isModalOpen={isErrorPopupOpen} setIsModalOpen={setIsErrorPopupOpen}>
                <div className={s.modal_content}>
                    <img src={closeCircle} className={s.circle} alt=""/>
                    <div className={s.popup_title}>
                        Failed!
                    </div>
                    <div className={s.popup_subtitle}>
                        {isEmailValid ? "Your email code hasn’t been verified. Please try again" : "Something went wrong. Please try again."}
                    </div>
                    <div className={s.popup_button_block}>
                        <MyBtn isPersonalAccountBtn buttonType="error" title={"Ok"} onClick={clearEmailInput}/>
                    </div>
                </div>
            </CustomModal>

            <h2 className={s.title}>Sell Currency</h2>
            <Table
                bordered={false}
                rowClassName={(record, index) => index % 2 !== 0 ? `${s.table_row_dark}` : ''}
                className={s.statementTable}
                columns={columns}
                pagination={false}
                //for info
                /*expandable={{
                    expandIcon: ({expanded, onExpand, record}) =>
                        (<img src={arrowDown} className={expanded ? s.open : s.close}
                              onClick={e => onExpand(record, e)}/>)
                    ,
                    expandedRowRender: (record) => <p style={{margin: 0}}>{record.description}</p>,
                    expandRowByClick: true,

                }}*/
                dataSource={tableData}
            />

            <div >
                {
                    props.exchangeData.map((exchange, index) => <div key={index} className={s.transfer_card_mobile}>
                        <div className={s.mobile_row}>
                            <div>
                                <p className={s.transfer_label}>from Account</p>
                                <p className={s.transfer_value}>{exchange.accNumberFrom}</p>
                            </div>
                        </div>

                        <div className={s.mobile_row}>
                            <div>
                                <p className={s.transfer_label}>To Account</p>
                                <p className={s.transfer_value}>{exchange.accNumberTo}</p>
                            </div>
                        </div>

                        <div className={s.mobile_row}>
                            <div>
                                <p className={s.transfer_label}>To buy</p>
                                <p className={s.transfer_value}>
                                    {(exchange.toAmount? exchange.toAmount : exchange.result) + ' ' + exchange.accNumberFromCurrency}
                                </p>
                            </div>

                            <div>
                                <p className={s.transfer_label}>To sell</p>
                                <p className={s.transfer_value}>
                                    {(exchange.amount ? exchange.amount : exchange.result) + ' ' + exchange.accNumberToCurrency}
                                </p>
                            </div>
                        </div>
                    </div>)
                }

            </div>

            <div className={s.buttonsWrapper}>
                <div className={s.button_block}>
                    <TransparentButton
                        title={'Back'}
                        isPersonalAccountBtn
                        large
                        icon={<Icon component={() => <Back/>} rev={undefined}/>}
                        onClick={() => props.setCurrent(0)}
                    />
                </div>
                <div className={s.button_block}>
                    {/* <MyBtn title={'Confirm'} isPersonalAccountBtn large onClick={() => sendExchangeData()}/> */}
                    <MyBtn title={'Confirm'} isPersonalAccountBtn large onClick={showEmailPinCodeModal}/>
                    {showEmailModalVerify ? <PopUpEmailCodConfirm getPinEmail={getEmailPin} onClose={closeEmailPinPopUp} /> : null}
                </div>
            </div>
        </div>
    );
};

export default ExchangeStepTwo;
